import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsAppWidget from "./components/FloatingWhatsAppWidget";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import PaintCorrection from "./pages/PaintCorrection";
import CeramicCoating from "./pages/CeramicCoating";
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import Booking from "./pages/Booking";
import MaintenanceDetail from "./pages/MaintenanceDetail";
import FullDetail from "./pages/FullDetail";
import UltimateDetail from "./pages/UltimateDetail";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/paint-correction" element={<PaintCorrection />} />
            <Route path="/ceramic-coating" element={<CeramicCoating />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/maintenance-detail" element={<MaintenanceDetail />} />
            <Route path="/full-detail" element={<FullDetail />} />
            <Route path="/ultimate-detail" element={<UltimateDetail />} />
          </Routes>
          <Footer />
          <FloatingWhatsAppWidget />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
